import * as blobApi from '../../modules/blobApi';
import {
  PRICE_PRO,
  PRICE_BUSINESS,
  SHOP_PACKAGE_ADDONS,
  PLATIN_PACKAGE_ADDONS,
  PLATINUM_PACKAGE_ADDONS,
  SEO_PACKAGE_ADDONS,
  DOMAIN_GROUP_TYPE_A,
} from '../../modules/constants';
import delay from '../../modules/delay';
import { isGermanLanguage } from '../../modules/helpers';
import { Action } from '../../definitions/types';
import { AppState, getLang } from '../reducers';
import { Dispatch, ThunkAction } from 'redux-thunk';
import * as Actions from './actions-consts';

export interface MobileSettingsPayload {
  os: string;
  isMobile: boolean;
}

export function mobileSettings(os: string, isMobile: boolean): Action<MobileSettingsPayload> {
  return {
    type: Actions.SET_MOBILE_SETTINGS,
    payload: { os, isMobile },
    meta: {
      tracked: { action: 'mobile-settings', label: 'set' },
    },
  };
}

export interface Prices {
  free: string;
  pro: string;
  business: string;
  shop: string;
  platin: string;
  seo: string;
  domain: string;
}

function retrievedPrices(prices: Prices): Action<Prices> {
  return {
    type: Actions.RETRIEVED_PRICES,
    payload: prices,
  };
}

// Helper function to get the currency symbol for each country right
// Can be remove when this is trough https://github.com/Jimdo/the-signup-flow/issues/252
function getFreePrice(proPrice: string): string {
  return proPrice.replace(/\d+(?:[,.]\d+)?/, '0');
}

const NUMBER_OF_ATTEMPTS = 7;
let retryTime = 500;
let retryAttempt = 0;
export function retrievePrices(): ThunkAction<void, AppState, void> {
  return async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    try {
      const pro = await blobApi.getPrice({ priceType: PRICE_PRO });
      const business = await blobApi.getPrice({ priceType: PRICE_BUSINESS });
      const language = getLang(getState());
      const platinAdditionalProducts = isGermanLanguage(language)
        ? PLATIN_PACKAGE_ADDONS
        : PLATINUM_PACKAGE_ADDONS;

      const shop = await blobApi.getPrice({
        priceType: PRICE_BUSINESS,
        additionalProducts: SHOP_PACKAGE_ADDONS,
      });
      const platin = await blobApi.getPrice({
        priceType: PRICE_BUSINESS,
        additionalProducts: platinAdditionalProducts,
      });
      const seo = await blobApi.getPrice({
        priceType: PRICE_BUSINESS,
        additionalProducts: SEO_PACKAGE_ADDONS,
      });
      const domain = await blobApi.getDomainPrice({
        domainGroupType: DOMAIN_GROUP_TYPE_A,
      });
      dispatch(
        retrievedPrices({
          pro,
          business,
          shop,
          platin,
          seo,
          free: getFreePrice(pro),
          domain,
        })
      );
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.warn(error);
      }

      if (retryAttempt === NUMBER_OF_ATTEMPTS - 1) {
        return;
      }
      await delay(retryTime);
      retryTime = retryTime * 2;
      retryAttempt += 1;
      dispatch(retrievePrices());
    }
  };
}

export function includeInClaimsTest(claimsVariant: string) {
  return {
    type: Actions.INCLUDE_IN_CLAIMS_TEST,
    payload: claimsVariant,
  };
}

export function forceIntoDolphin() {
  return {
    type: Actions.FORCE_INTO_DOLPHIN,
  };
}

// TODO clean-up GRW-1410 GRW-1416
export function setLoadingCTA(loading: boolean) {
  return {
    type: Actions.SET_LOADING_CTA,
    payload: loading,
  };
}

// TODO clean-up GRW-1410 GRW-1416
export function setLoadingPage(loading: boolean) {
  return {
    type: Actions.SET_LOADING_PAGE,
    payload: loading,
  };
}

// TODO clean-up GRW-1410 GRW-1416
export function setToSAcceptanceStatus(status: boolean) {
  return {
    type: Actions.SET_TOS_ACCEPTANCE_STATUS,
    payload: status,
  };
}

// TODO clean-up GRW-1410 GRW-1416
export function setUserHasBusiness(userHasBusiness: boolean) {
  return {
    type: Actions.SET_USER_HAS_BUSINESS,
    payload: userHasBusiness,
  };
}
